<template>
    <div
        data-testid="step-uploadFailed"
        class="container container--slim step--upload-result step--upload-result--failed"
    >
        <h1 class="container__client-zone-header">
            {{ $t(`${TRANSLATION_KEY}.headerOne`) }}
        </h1>
        <div class="image-wrapper">
            <img class="w-80" src="@/assets/partial.svg" />
        </div>

        <div v-if="uploadDocumentCount === 1" class="row">
            <p ref="responseText" class="responseText">
                {{ $t(`${TRANSLATION_KEY}.uploadCountOneMessage`) }}
            </p>
            <SubmitButton
                data-testid="btn-uploadFailed-tryAgain"
                :action="action.UPLOAD_TRY_AGAIN"
                class="button button--submit"
                :data="{}"
            >
                {{ $t(`${TRANSLATION_KEY}.uploadAgain`) }}
            </SubmitButton>
            <SubmitButton
                :action="action.UPLOAD_SUMMARY"
                data-testid="btn-uploadFailed-skip"
                class="button button--skip"
                cy-data="go-to-personal-data"
                :data="{}"
            >
                {{ $t(`${TRANSLATION_KEY}.skipAndContinue`) }} »
            </SubmitButton>
        </div>
        <div v-else class="row space">
            <p v-if="uploadDocumentCount === 2" class="responseText">
                {{ $t(`${TRANSLATION_KEY}.uploadCountTwoMessage`) }}
            </p>
            <SubmitButton
                :action="action.UPLOAD_SUMMARY"
                class="button button--submit"
                data-testid="btn-uploadFailed-nextStep"
                cy-data="go-to-personal-data"
                :data="{}"
            >
                {{ $t(`${TRANSLATION_KEY}.nextStep`) }}
            </SubmitButton>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import SubmitButton from '@/components/basic/buttons/SubmitButton.vue';
import { DocumentType } from '@/constants/form-values';
import { Action } from '@/constants/ajax';
import { SET_STEP } from '@/constants/mutation-types';

export default defineComponent({
    name: 'UploadFailed',
    components: {
        SubmitButton,
    },
    setup() {
        const store = useStore();

        const uploadDocumentCount = computed(
            () => store.state.uploadDocumentCount
        );

        const TRANSLATION_KEY = 'steps.UploadFailed';
        const docType = DocumentType;

        const action = Action;

        const fetchDataId = () => {
            if (store.state.gbgToken && store.state.journeyId) {
                const journeyId = store.state.journeyId;
                const gbgToken = store.state.gbgToken;
                fetch(
                    `https://poc.idscan.cloud/idscanenterprisesvc/journey/get?journeyId=${journeyId}`,
                    {
                        headers: { Authorization: gbgToken },
                    }
                ).then((response: any) => {
                    response.json().then((data: any) => {
                        if (data.ProcessedDocuments) {
                            store.state.clientIdData = data.ProcessedDocuments;
                        }
                    });
                });
            }
        };

        onMounted(() => {
            fetchDataId();
            store.commit(SET_STEP, 'uploadFailed');
        });

        return {
            TRANSLATION_KEY,
            uploadDocumentCount,
            docType,
            action,
        };
    },
});
</script>

<style>
.space {
    margin-top: 50px;
}
.responseText {
    margin-top: 50px;
    text-align: center;
    margin-bottom: 20px;
}
</style>
